<div
  class="searchable-dropdown-wrapper"
  [class.disabled]="disabled()"
  appClickOutside
  (clickOutside)="onOutsideClick()"
>
  <!-- Dropdown trigger -->
  <div
    class="searchable-dropdown-trigger"
    [class.searchable-dropdown-trigger--minimal]="triggerAppearance() === 'minimal'"
    [class.searchable-dropdown-trigger--compact]="triggerAppearance() === 'compact'"
    [class.open]="isOpen()"
    [class.disabled]="disabled()"
    (click)="toggle()"
  >
    <span class="searchable-dropdown-text">
      @if (isPhoneLabel(displayText())) {
        <span [innerHTML]="displayText() | phoneNumberFormat: false"></span>
      } @else {
        {{ displayText() }}
      }
    </span>
    <ng-icon name="tablerChevronDown" class="searchable-dropdown-icon" />
  </div>

  <!-- Dropdown menu -->
  @if (isOpen()) {
    <div
      class="searchable-dropdown-menu"
      [class.searchable-dropdown-menu--align-end]="panelHorizontalAlign() === 'end'"
      #dropdownMenu
    >
      @if (showSearch()) {
        <div class="searchable-dropdown-search" (click)="onSearchClick($event)">
          <div class="searchable-dropdown-search-input">
            <ng-icon name="tablerSearch" class="searchable-dropdown-search-icon" />
            <input
              type="text"
              class="searchable-dropdown-search-field form-control"
              [placeholder]="searchPlaceholder()"
              [value]="searchTerm()"
              (input)="onSearchInput($event)"
            />
          </div>
        </div>
      }

      <div class="searchable-dropdown-list">
        @if (filteredOptions().length > 0) {
          @if (mode() === 'single') {
            @for (option of filteredOptions(); track option.value) {
              <div
                class="searchable-dropdown-option"
                [class.selected]="isSelected(option)"
                [class.disabled]="option.disabled"
                (click)="selectSingle(option)"
              >
                <span class="searchable-dropdown-option-label">
                  @if (isPhoneLabel(option.label)) {
                    <span [innerHTML]="option.label | phoneNumberFormat: false"></span>
                  } @else {
                    {{ option.label }}
                  }
                </span>
                @if (optionVariant() === 'navigation') {
                  <ng-icon name="tablerChevronRight" class="searchable-dropdown-nav-icon" />
                } @else if (isSelected(option)) {
                  <ng-icon name="tablerCheck" class="searchable-dropdown-check-icon" />
                }
              </div>
            }
          }

          @if (mode() === 'multi') {
            @for (option of filteredOptions(); track option.value) {
              <div
                class="searchable-dropdown-option searchable-dropdown-option--multi"
                [class.disabled]="option.disabled"
              >
                <app-form-checkbox
                  [checked]="isSelected(option)"
                  [disabled]="option.disabled ?? false"
                  (checkedChange)="toggleMulti(option)"
                />
                <span class="searchable-dropdown-option-label">
                  @if (isPhoneLabel(option.label)) {
                    <span [innerHTML]="option.label | phoneNumberFormat: false"></span>
                  } @else {
                    {{ option.label }}
                  }
                </span>
              </div>
            }
          }
        } @else {
          <div class="searchable-dropdown-empty">No options available</div>
        }
      </div>
    </div>
  }
</div>
